import { render, staticRenderFns } from "./SectionNew.vue?vue&type=template&id=ba7e65f6&"
import script from "./SectionNew.vue?vue&type=script&lang=js&"
export * from "./SectionNew.vue?vue&type=script&lang=js&"
import style0 from "./SectionNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports